import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Forbidden } from "iconsax-react";

// Rebuilt (2026-09-08, UI polish pass) to match ExpiredServiceBox.jsx's
// convention -- left-aligned icon+text instead of everything centered inside
// a wide, mostly-empty banner, MUI's Block icon swapped for Iconsax's
// Forbidden (the same glyph InboxSettings.jsx's own "Blocked Contacts" tab
// uses, see icon-library-iconsax memory), and fixed title/subtitle sizes
// (0.875rem/0.8125rem) instead of a 5-breakpoint scattered scale that read
// as illegible at xs/sm.
/** Shown in place of the compose box when the open contact is blocked (see TextBox.jsx). */
const BlockedContactBox = ({ blockedByName }) => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "dark"
            ? alpha(theme.palette.error.main, 0.12)
            : "#fde3e1",
        border: (theme) =>
          theme.palette.mode === "dark"
            ? `1px solid ${alpha(theme.palette.error.light, 0.35)}`
            : `1px solid ${alpha("#611a15", 0.12)}`,
        borderRadius: "12px",
        padding: { xs: "16px 18px", sm: "20px 24px" },
        display: "flex",
        alignItems: "center",
        gap: "10px",
        maxWidth: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
        margin: "auto",
        mb: { xs: "8px", sm: "12px", md: "20px" },
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
            ? `0 2px 12px ${alpha("#000", 0.35)}`
            : "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          width: 22,
          height: 22,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: (theme) => (theme.palette.mode === "dark" ? theme.palette.error.light : "#611a15"),
        }}
      >
        <Forbidden size="100%" variant="Bold" color="currentColor" />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.875rem",
            lineHeight: 1.3,
            color: (theme) => (theme.palette.mode === "dark" ? theme.palette.text.primary : "#611a15"),
          }}
        >
          This contact is blocked
        </Typography>
        <Typography
          sx={{
            fontSize: "0.8125rem",
            lineHeight: 1.4,
            mt: "3px",
            color: (theme) =>
              theme.palette.mode === "dark" ? alpha(theme.palette.common.white, 0.78) : alpha("#5d1712", 0.92),
          }}
        >
          {blockedByName
            ? `Blocked by ${blockedByName}. Unblock this contact to send messages.`
            : "Unblock this contact to send messages."}
        </Typography>
      </Box>
    </Box>
  );
};

export default BlockedContactBox;
